import { render } from "./AboutContacts.vue?vue&type=template&id=2fe08cd6"
import script from "./AboutContacts.vue?vue&type=script&lang=js"
export * from "./AboutContacts.vue?vue&type=script&lang=js"

import "./AboutContacts.vue?vue&type=style&index=0&id=2fe08cd6&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@5.9.3__webpack@5.107.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__